export default __webpack_public_path__ + "static/media/pl.1d699fb1.svg";